import { FetchProjectsTasksSortTypes } from './projectsTasksTypes';

export const INITIAL_PROJECTS_TASKS_FILTERS = {};
export const INITIAL_PROJECTS_TASKS_LIMIT = 50;
export const INITIAL_PROJECTS_TASKS_PAGE = 1;
export const INITIAL_PROJECTS_TASKS_SORT = [
  FetchProjectsTasksSortTypes.CREATED_AT_DESC
];

export const enum ProjectsTasksPermissions {
  READ_PROJECTS_TASKS_TABLE_SKU_FIELD = 'read_projects_tasks_table_sku_field',
  EDIT_PROJECTS_TASKS_TABLE_SKU_FIELD = 'edit_projects_tasks_table_sku_field',
  READ_PROJECTS_TASKS_TABLE_NOTES_FIELD = 'read_projects_tasks_table_notes_field',
  READ_PROJECTS_TASKS_TABLE_DRAG_PROJECTS_TASKS = 'read_projects_tasks_table_drag_projects_tasks',
  READ_PROJECTS_TASKS_TREE_DROP_PROJECTS_TASKS = 'read_projects_tasks_tree_drop_projects_tasks',
  READ_PROJECTS_TASKS_TREE_DROP_ITEMS = 'read_projects_tasks_tree_drop_items',
  EDIT_PROJECTS_TASKS_TABLE_NOTES_FIELD = 'edit_projects_tasks_table_notes_field',
  READ_PROJECTS_TASKS_INDEX_ES_QUERY = 'read_projects_tasks_index_es_query',
  READ_PROJECTS_TASK_SHOW_ES_QUERY = 'read_projects_task_show_es_query',
  READ_PROJECTS_TASKS_MENU_PROJECT_TREE = 'read_projects_tasks_menu_project_tree'
}

export const PROJECTS_TASK_DND_NODE = 'NODE';
